export const DOKU_STATUS = {
  PENDING: { label: "Menunggu", tint: "bg-amber-50 text-amber-700" },
  PAID: { label: "Lunas", tint: "bg-emerald-50 text-emerald-700" },
  EXPIRED: { label: "Kedaluwarsa", tint: "bg-slate-100 text-slate-600" },
  FAILED: { label: "Gagal", tint: "bg-rose-50 text-rose-700" },
  CREATE_FAILED: { label: "Gagal dibuat", tint: "bg-rose-100 text-rose-800" },
};
export const statusDef = (s) => DOKU_STATUS[s] || { label: s || "—", tint: "bg-slate-100 text-slate-600" };

export const fmtWib = (iso, withSec = false) => (iso ? new Date(iso).toLocaleString("id-ID", { timeZone: "Asia/Jakarta", day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", ...(withSec ? { second: "2-digit" } : {}) }) + " WIB" : "—");
// Calendar date in WIB (Asia/Jakarta), not UTC.
export const isoDate = (d) => d.toLocaleDateString("en-CA", { timeZone: "Asia/Jakarta" });
export const channelLabel = (c) => (c ? String(c).replace(/_/g, " ") : "—");
export const PAGE_SIZE = 50;
